import { getGrpcPromise } from '@monorepo/grpc';
import { PaginationRequest } from '@spilca/order_ts/v1/order/common_pb';
import { OrderService } from '@spilca/order_ts/v1/order_web/order_web_pb_service';
import { ListOrderFileRequest } from '@spilca/order_ts/v1/order/model_order_pb';

const getListOrderFiles = (queryKey: any) => {
  const getFiles = getGrpcPromise(OrderService.ListOrderFile);
  const id = queryKey[1];

  const request = new ListOrderFileRequest();
  const pagination = new PaginationRequest();
  pagination.setPageSize(100);
  request.setPagination(pagination);
  request.setOrderId(Number(id));
  return getFiles(request);
};

export default getListOrderFiles;
